import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ConfigDropdown from "../components/ConfigDropdown";
import UploadProgress from "../components/ProgressSocketComponent";
import axios from "axios";
import api from "../api";
import { apiFetch } from "../apiFetch";
import MetricCard from "../components/MetricCard";
import ColumnMappingTable from "../components/column_mapping/ColumnMappingTable";

export default function ConfigListPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { configName } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedConfig, setEditedConfig] = useState({});
  const [file2Cols, setFile2Cols] = useState([])

  const [program, setProgram] = useState({});
  const [configs, setConfigs] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  const [sourceFile, setSourceFile] = useState(null);
  const [targetFile, setTargetFile] = useState(null);

  const [uploadingSource, setUploadingSource] = useState(false);
  const [uploadingTarget, setUploadingTarget] = useState(false);
  const [running, setRunning] = useState(false);
  const [uploadedFileId, setUploadedFileId] = useState(1);
  const [updatedConfigName, setUpdatedConfigName] = useState(null);
  const [uploadStatus, setUploadStatus] = useState({
    source: null, // "success" | "error" | null
    target: null,
  });

  const [result, setResult] = useState(null);
  const [uploadId, setUploadeId] = useState(null);
  const [fileProcessingStatus, setFileProcessingStatus] = useState(null)

  const [rules,setRules] = useState([])

  const isSourceUploaded = uploadStatus.source === "success";

  /* ================= FETCH CONFIGS ================= */
  useEffect(() => {
    if (state) {
      setProgram(state.program);
      getConfigById(state.config.id);
      setSelectedId(state.config.id);
    }

    apiFetch("file-mapping-config/config/"+state?.program?.id)
      .then((res) => res.json())
      .then(setConfigs)
      .catch(console.error);
  }, []);

  const handleSelect = async (id) => {
    setSelectedId(id);
    if (!id) return setSelectedConfig(null);

    setLoading(true);
    await getConfigById(id);
  };

    const updateMapping_ = (index, field, value) => {
    
      console.log("updateMapping******* ", index,field,value);
      if(field=="isNumber"){
        field = "dataType";
        value = value?"Number":"String"
      }
      console.log(selectedConfig.columnMappings)
    const updated = [...selectedConfig.columnMappings];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };

    setEditedConfig({
      ...editedConfig,
      mappings: updated,
    });
    selectedConfig.columnMappings[index][field]= value;
    console.log(updated[index])
  };

  const updateMapping = (index, field, value) => {
    const updated = [...selectedConfig.columnMappings];

    if (field === "targetColumn") {
      updated[index][field] = value;
      updated[index].targetColumnIndex = file2Cols.indexOf(value);
    } else if (field === "dataType") {
      updated[index][field] = value;
    }else if (field === "transformRuleId") {
      updated[index][field] = value;
    } else if (field === "allowedDiff") {
      updated[index][field] = Number(value); // IMPORTANT
    } else if (field === "isMaster") {
      updated[index][field] = !updated[index][field];
    } else if (field === "finalOutput"){
      //Only One FinalOutput Column
      selectedConfig.columnMappings.forEach((element,index) => {
        element["finalOutput"] = false;
      });
      updated[index][field] = !updated[index][field];
    }
    else {
      updated[index][field] = !updated[index][field];
    }


    setEditedConfig({
      ...selectedConfig,
      mappings: updated,
    })

   // setMappings(updated);
  };


  /**
   * 
   * @param {*} id 
   */
    const saveConfig = async () => {
    try {
      editedConfig.mappings = selectedConfig?.columnMappings;
      editedConfig.programId = program.id;
      if(updatedConfigName){
        editedConfig.configName = updatedConfigName;
      }
      const res = await apiFetch(
         "file-mapping-config",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editedConfig),
        }
      );

      if (!res.ok) throw new Error("Failed");

      alert("Configuration updated successfully");

      setIsEditMode(false);
      setSelectedConfig(editedConfig);

    } catch (err) {
      console.error(err);
      alert("Save failed");
    }
  };

  const deleteRow = (index) => {
  const updated = editedConfig.columnMappings.filter((_, i) => i !== index);
  setEditedConfig({
    ...editedConfig,
    columnMappings: updated,
  });
};

  const getConfigById = async (id) => {
    try {
      const res = await apiFetch(
        `file-mapping-config/${id}`
      );
      const data = await res.json();
      if(data && data.length>0){
        setFile2Cols(data[0]?.targetColumns);
        setSelectedConfig(data[0]);
        setEditedConfig(data[0]);
      } 

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= UPLOAD ================= */

  const uploadSourceFile = async (file) => {
    if (!selectedId) return alert("Select config first");

    const formData = new FormData();
    formData.append("configId", selectedId);
    formData.append("file", file);

    setUploadingSource(true);

    try {
      const res = await apiFetch(
         "file-mapping-config/upload-source",
        { method: "POST", body: formData }
      );
      const data = await res.json();
      setUploadedFileId(data.uploadedFileId);
      setUploadeId(data.uploadId);
      setUploadStatus((prev) => ({
      ...prev,
      source: "success",
    }));
    } catch {
      setUploadStatus((prev) => ({
      ...prev,
      source: "error",
    }));
      alert("Source upload failed");
    } finally {
      setUploadingSource(false);
    }
  };

  const uploadTargetFile = async (file) => {
    if (!selectedId) return alert("Select config first");

    const formData = new FormData();
    formData.append("configId", selectedId);
    formData.append("uploadedFileId", uploadedFileId);
    formData.append("file", file);

    try {
      const res= await apiFetch(
        "file-mapping-config/upload-target",
        { method: "POST", body: formData }
      );
      const data = await res.json();
      setUploadingTarget(true);
      setUploadeId(data.uploadId);
      setUploadStatus((prev) => ({
      ...prev,
      target: "success",
    }));
    } catch {
      setUploadStatus((prev) => ({
      ...prev,
      target: "error",
    }));
      alert("Target upload failed");
      
    } finally {
      setUploadingTarget(false);
    }
  };

  /* ================= RUN ================= */

  const runProcess = async () => {
    if (!selectedId) return alert("Select config");

    setRunning(true);

    try {
      const res = await apiFetch(
        "file-mapping-config/compare",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: selectedId,
            uploadedFileId: uploadedFileId,
          }),
        }
      );

      const data = await res.json();
      setResult(data);
    } catch {
      alert("Process failed");
    } finally {
      setRunning(false);
    }
  };

  /**========Fetch Transfomation Rules=========================== */

   useEffect(() => {
      fetchRules();
    }, []);
  const fetchRules = async () => {
    try {
      setLoading(true);

      const res = await api.get("transformation-rules");

      setRules(res?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
 /**============================================= */

  return (
   <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 min-h-screen flex flex-col">
      
      {/* MAIN */}
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">
      
      {/* HEADER */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm mb-6 flex items-center justify-between">
            <div>
              <div className="text-xs font-black tracking-[0.3em] text-slate-400 uppercase">
                Reconciliation
              </div>

              <h1 className="mt-2 text-2xl font-black text-slate-900">
                Run Reconciliation
              </h1>

              <p className="mt-2 text-slate-500">
                Select Config And Upload Source & Target File.
              </p>

              <p className="mt-2 text-slate-500">
               Program: {program?.programName}
              </p>
            </div>
            <div>
              <button
                onClick={() => navigate("/")}
                className="text-blue-600 font-medium"
              >
                ← Back to Dashboard
              </button>
           </div>
        </div>
      {/* <div className="flex justify-between items-center mb-6 max-w-[1400px] mx-auto">
        <h1 className="text-2xl font-bold">Run Reconciliation</h1>

        <button
          onClick={() => navigate("/")}
          className="text-blue-600 font-medium"
        >
          ← Back to Dashboard
        </button>
      </div> */}

      <div className="max-w-[1400px] mx-auto space-y-6">

        {/* SELECT CONFIG */}
        <ConfigDropdown handleSelect={handleSelect} selectedId={selectedId} configs={configs}>

        </ConfigDropdown>
        {/* CONFIG DETAILS */}
        {selectedConfig && (
          <ColumnMappingTable
                    mappings={selectedConfig.columnMappings}
                    file2Cols={file2Cols}
                    rules={rules}
                    updateMapping={updateMapping}
                    saveConfig={saveConfig}
                    setIsEditMode={setIsEditMode}
                    isEditMode={isEditMode}
                    showEdit={true}
                   
                  />
          
        )}

       {(selectedId && <div className="flex justify-between items-center mb-6 max-w-[1400px] mx-auto">
          <h1 className="text-2xl font-bold"></h1>
          <button
            onClick={() =>  navigate(`/programs/config/column-mapping/${selectedConfig.configName}`, {
              state: {
                "file_mapping_id": selectedId
              },
          })}
            className="text-blue-600 font-medium"
          >
            Create Column Mapping
          </button>
        </div>)}

        {/* UPLOAD SECTION */}
        {selectedConfig && (
          <div className="bg-white border rounded-xl p-6">

            <h3 className="text-lg font-bold mb-4">Upload Files</h3>

            <div className="grid md:grid-cols-2 gap-6">

              {/* SOURCE */}
              <UploadBox
                title="Source File"
                loading={uploadingSource}
                file={sourceFile}
                onChange={(file) => {
                  setSourceFile(file);
                  uploadSourceFile(file);
                  
                }}
                uploadStatus={uploadStatus}
                type={'source'}
                uploadId={uploadId}
                setFileProcessingStatus={setFileProcessingStatus}

              />
            
              {/* TARGET */}
              <UploadBox
                title="Target File"
                loading={uploadingTarget}
                file={targetFile}
                disabled={!isSourceUploaded}   //  disable until source uploaded
                onChange={(file) => {
                  if (!isSourceUploaded) return; // extra safety
                  setTargetFile(file);
                  uploadTargetFile(file);
                }}
                uploadStatus={uploadStatus}
                type={'target'}
                uploadId={uploadId}
                setFileProcessingStatus={setFileProcessingStatus}
              />

              {/* Hint message */}
              {!isSourceUploaded && (
                <p className="text-xs text-gray-500 mt-2">
                  ⚠️ Upload Source file first
                </p>
              )}
            </div>

            {/* <button
              onClick={runProcess}
              disabled={!(uploadStatus.source=="success" && uploadStatus.target=="success")}
              className="mt-6 bg-primary text-white px-6 py-2 rounded-lg"
            >
              {running ? "Processing..." : "Run Reconciliation"}
            </button> */}
          </div>
        )}

        {/* <!-- Bottom Bar: Validation & Actions --> */}
        
        {selectedConfig && uploadStatus.target=='success'  && ( 
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-white border border-slate-200 p-6 rounded-xl mb-6 shadow-lg">
              <div className="flex items-center gap-4">
                <div className="size-12 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center border border-emerald-100">
                  {/* <span className="material-symbols-outlined">verified</span> */}
                </div>
                {/* <div>
                  <h4 className="text-sm font-bold text-slate-900">Validation Status</h4>
                  <p className="text-xs text-emerald-600 font-medium">Unique key identifies 100% of rows (4,209 unique records detected).</p>
                </div> */}
              </div>
              <div className="flex gap-4 w-full md:w-auto">
                {/* <button  onClick={saveMapping}
                  className="flex-1 md:flex-none h-12 px-8 rounded-lg bg-white text-slate-700 font-bold hover:bg-slate-50 transition-all border border-slate-200">
                  Save Configuration
                </button> */}
                <button onClick={runProcess}
                  disabled={!(uploadStatus.source=="success" && uploadStatus.target=="success")}

                  className="flex-1 md:flex-none h-12 px-8 rounded-lg bg-primary text-white font-black shadow-lg shadow-primary/10 hover:brightness-110 transition-all flex items-center justify-center gap-2">
                  <span>{running ? "Processing..." : "Run Reconciliation"}</span>
                  {/* <span className="material-symbols-outlined">bolt</span> */}
                </button>
              </div>
         </div> )}
        {result && (
              <div className="mt-8 space-y-6">

                 {/* FILE LEVEL STATS */}
                <div className="bg-white border rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-4">File Summary</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                      <MetricCard title="Source Only" value={result.data.files_records.source_only_count}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
                      <MetricCard title="Target Only" value={result.data.files_records.target_only_count}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
                      <MetricCard title="Matched" value={result.data.files_records.matched_count}  desc = "Transaction Unique ID" color="text-emerald-600" bg="bg-emerald-50"/>
                  </div>
                </div>

                {/* SUMMARY CARDS */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <MetricCard title="Total Records" value={result.data.total}  desc = "Transactions" color="text-emerald-600" bg="bg-emerald-50"/>
                  <MetricCard title="Matched" value={result.data.matched}  desc = "Transactions Final Output" color="text-emerald-600" bg="bg-emerald-50"/>
                  <MetricCard title="Mismatched" value={result.data.mismatched}  desc = "Transactions Final Output" color="text-rose-600" bg="bg-rose-50"/>
                  <MetricCard title="Accuracy" value={`${Number(result.data.accuracy).toFixed(2)}%`}  desc = "" color="text-emerald-600" bg="bg-emerald-50"/>
                </div>

               

                {/* ACTION BUTTON */}
                <div className="flex justify-end">
                  <button
                    onClick={() =>
                      // navigate(`/reconciliation-summary/${result.runId}`, {
                      //   state: result,
                      // })
                      navigate(`/programs/config/run/summary/${selectedConfig.configName}`, {
                        state: {...configs,config_name:selectedConfig.configName,file_mapping_id:selectedConfig.id,id:uploadedFileId,accuracy:configs.accuracy},
                      })
                    }
                    className="text-blue-600 font-semibold"
                  >
                    View Full Report →
                  </button>
                </div>

              </div>
            )} 
      </div>
      </main>
    </div>
  );
}

/* ================= COMPONENTS ================= */

function UploadBox({
  title,
  loading,
  file,
  onChange,
  uploadStatus,
  type,
  disabled = false, //  NEW
  uploadId,
  setFileProcessingStatus
}) {
  return (
    <div
      className={`border-2 border-dashed rounded-xl p-6 text-center transition
        ${disabled ? "bg-gray-100 cursor-not-allowed opacity-60" : "hover:border-blue-500 cursor-pointer"}
      `}
    >
      <input
        type="file"
        accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        className="hidden"
        id={title}
        disabled={disabled} //  disable input
        onChange={(e) => {
          if (disabled) return; // extra safety
          onChange(e.target.files[0]);
        }}
      />

      <label
        htmlFor={disabled ? undefined : title} // prevent click when disabled
        className={disabled ? "cursor-not-allowed" : "cursor-pointer"}
      >
        <p className="font-semibold">{title}</p>

        <p className="text-sm text-slate-500">
          {loading
            ? "Uploading..."
            : disabled
            ? "Upload Source first"
            : "Click to upload"}
        </p>

        {file && <p className="mt-2 text-xs">{file.name}</p>}
      </label>

      {/* ✅ SOURCE STATUS */}
      {/* {file && type === "source" && uploadStatus.source === "success" && (
        <div className="text-green-600 text-sm mt-1">
          ✅ Source uploaded successfully
        </div>
      )} */}

      {file && type === "source" && uploadStatus.source === "error" && (
        <div className="text-red-600 text-sm mt-1">
          ❌ Source upload failed
        </div>
      )}

      {/* ✅ TARGET STATUS (FIXED BUG) */}
      {/* {file && type === "target" && uploadStatus.target === "success" && (
        <div className="text-green-600 text-sm mt-1">
          ✅ Target uploaded successfully
        </div>
      )} */}

      {file && type === "target" && uploadStatus.target === "error" && (
        <div className="text-red-600 text-sm mt-1">
          ❌ Target upload failed
        </div>
      )}
      {((type === "target" && uploadStatus.target === "success") || (type === "source" && uploadStatus.source === "success")) && <UploadProgress uploadId={uploadId} onProgress={setFileProcessingStatus}></UploadProgress>}

    </div>
  );
}

function SummaryCard({ title, value }) {
  return (
    <div className="bg-white border rounded-xl p-5">
      <p className="text-sm text-slate-500">{title}</p>
      <p className="text-2xl font-bold mt-2">{value}</p>
    </div>
  );
}

